import type { ModernBusinessDecryptResponse } from '@onefootprint/request-types';

/**
 * Sensitive business DIs that cannot be decrypted with a normal token.
 * These fields require special permissions (similar to SSN for user data).
 */
const SENSITIVE_BUSINESS_DIS: (keyof ModernBusinessDecryptResponse)[] = ['business.tin'];

/**
 * Filters out sensitive business DIs from the list.
 * This prevents 403 errors when trying to decrypt fields the token doesn't have permission for.
 */
export const filterSensitiveBusinessDis = (
  fields: (keyof ModernBusinessDecryptResponse)[],
): (keyof ModernBusinessDecryptResponse)[] => {
  return fields.filter(field => !SENSITIVE_BUSINESS_DIS.includes(field));
};
